
export default {
  space: [0, "0.2rem", "0.8rem", "1.6rem", "3.2rem", "6.4rem", "12.8rem", "25.6rem", "51.2rem"],
  fontSize: [
    0,
    "1.6rem",
    "2.4rem",
    "3.2rem",
    "3.8rem",
    "4.2rem",
    "5rem",
    "6rem",
  ],
  colors: {
    primary: "#f16541",
    warning: "#b22400",
    white: "#ffffff",
    grey: "#808184",
    lightgrey: "#e1e1e1",
    blue: "#41a6f9",
    black: "black",
    transparent: "transparent",
    bggray: "#f8f8f8",
  }
};


// WEBPACK FOOTER //
// ./src/styles/theme.ts